import moment from 'moment';

import {
  locationChangePersist,
  storeDefault,
  storeRequest,
  storeFilled,
  ListStoreDefault,
  ListRequestHandler,
  ListFilterHandler,
  ListSuccessHandler,
  setCompetitorState,
  setSubscriptionState,
} from 'js/helpers/reducers';

import {
  FETCH_PUBLISHER_METADATA,
  FETCHED_PUBLISHER_METADATA,
  FETCH_PUBLISHER_TOP_KEYWORDS,
  FETCHED_PUBLISHER_TOP_KEYWORDS,
  SET_PUBLISHER_TOP_KEYWORDS_FILTER,
  FETCH_PUBLISHER_CONTENT_OVER_TIME,
  FETCHED_PUBLISHER_CONTENT_OVER_TIME,
  SET_PUBLISHER_CONTENT_OVER_TIME_FILTER,
  FETCH_PUBLISHER_PARTNERSHIPS,
  FETCHED_PUBLISHER_PARTNERSHIPS,
  FETCH_PUBLISHER_PAID_CONTENT,
  FETCHED_PUBLISHER_PAID_CONTENT,
  SET_PUBLISHER_PAID_CONTENT_FILTER,
  FETCH_PUBLISHER_TOP_BRANDS,
  FETCHED_PUBLISHER_TOP_BRANDS,
  SET_PUBLISHER_TOP_BRANDS_FILTER,
} from 'components/Pages/Entity/actions';

import {
  CREATED_USER_PUBLISHER_COMPETITOR,
  REMOVED_USER_PUBLISHER_COMPETITOR,
  REMOVED_USER_PUBLISHER_SUBSCRIPTION,
  CREATED_USER_PUBLISHER_SUBSCRIPTION,
} from 'components/Pages/Settings/actions.js';

const defaultDateFilters = {
  pageNum: 1,
  pageSize: 6,
  start_date: moment().subtract(365, 'day').format('YYYY-MM-DD'),
  end_date: moment().format('YYYY-MM-DD'),
};

const defaultState = {
  metadata: storeDefault({}),
  paidContentList: ListStoreDefault({
    pageNum: 1,
    pageSize: 40,
    start_date: '',
    end_date: '',
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    publisher_ids: [],
    searchQuery: '',
    content_type: 'paid',
    sort_by: 'publish_date',
    sort_order: 'desc',
  }),
  paidPartnershipList: ListStoreDefault({
    pageNum: 1,
    pageSize: 40,
    start_date: '',
    end_date: '',
    keyword_tags: [],
    categories: [],
    brand_ids: [],
    publisher_ids: [],
    searchQuery: '',
    content_type: 'paid',
    sort_order: 'desc',
    sort_by: 'num_contents',
  }),
  topBrandList: ListStoreDefault({
    ...defaultDateFilters,
    sort_order: 'desc',
    sort_by: 'num_contents',
  }),
  topKeywordList: ListStoreDefault({
    ...defaultDateFilters,
    sort_order: 'desc',
    sort_by: 'num_contents',
  }),
  contentOverTimeList: storeDefault({}, { filters: { content_type: 'paid', ...defaultDateFilters } }),
};

// eslint-disable-next-line complexity
const PublisherProfileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return locationChangePersist(state, action, defaultState, {
        persistEverything: true,
        pathToMatch: `/blueprint/${state.metadata.data.type}/${state.metadata.data.public_id}`,
      });
    case FETCH_PUBLISHER_PAID_CONTENT:
      return ListRequestHandler(state, action, 'paidContentList');
    case FETCHED_PUBLISHER_PAID_CONTENT:
      return ListSuccessHandler(state, action, 'paidContentList');
    case SET_PUBLISHER_PAID_CONTENT_FILTER: {
      const updatedState = ListFilterHandler(state, action, 'paidContentList');
      return ListFilterHandler(updatedState, action, 'paidPartnershipList');
    }
    case FETCH_PUBLISHER_PARTNERSHIPS:
      return ListRequestHandler(state, action, 'paidPartnershipList');
    case FETCHED_PUBLISHER_PARTNERSHIPS:
      return ListSuccessHandler(state, action, 'paidPartnershipList');
    case FETCH_PUBLISHER_METADATA:
      return Object.assign({}, state, { metadata: storeRequest({}) });
    case FETCHED_PUBLISHER_METADATA:
      return Object.assign({}, state, { metadata: storeFilled(action) });
    case FETCH_PUBLISHER_TOP_BRANDS:
      return ListRequestHandler(state, action, 'topBrandList');
    case FETCHED_PUBLISHER_TOP_BRANDS:
      return ListSuccessHandler(state, action, 'topBrandList');
    case SET_PUBLISHER_TOP_BRANDS_FILTER:
      return ListFilterHandler(state, action, 'topBrandList');
    case FETCH_PUBLISHER_TOP_KEYWORDS:
      return ListRequestHandler(state, action, 'topKeywordList');
    case FETCHED_PUBLISHER_TOP_KEYWORDS:
      return ListSuccessHandler(state, action, 'topKeywordList');
    case SET_PUBLISHER_TOP_KEYWORDS_FILTER:
      return ListFilterHandler(state, action, 'topKeywordList');
    case FETCH_PUBLISHER_CONTENT_OVER_TIME:
      return ListRequestHandler(state, action, 'contentOverTimeList');
    case FETCHED_PUBLISHER_CONTENT_OVER_TIME:
      return Object.assign({}, state, {
        contentOverTimeList: storeFilled(action, {
          filters: state.contentOverTimeList.filters,
        }),
      });
    case SET_PUBLISHER_CONTENT_OVER_TIME_FILTER:
      return ListFilterHandler(state, action, 'contentOverTimeList');
    case CREATED_USER_PUBLISHER_COMPETITOR:
      return setCompetitorState(state, action, true);
    case REMOVED_USER_PUBLISHER_COMPETITOR:
      return setCompetitorState(state, action, false);
    case CREATED_USER_PUBLISHER_SUBSCRIPTION:
      return setSubscriptionState(state, action, true);
    case REMOVED_USER_PUBLISHER_SUBSCRIPTION:
      return setSubscriptionState(state, action, false);
    default:
      return { ...state };
  }
};

export default PublisherProfileReducer;
